export default __webpack_public_path__ + "static/media/AppointmentDetails.7907e981.svg";